export default __webpack_public_path__ + "static/media/img0.28d123b0.png";